import { Person } from '@features/events/common/information';
import { parseAddress } from 'library/helpers/events/address';
import { getEventDaysHours } from 'library/helpers/events/dateSets';
import type { Event } from 'library/models/events';
import * as st from './styles.module.scss';
import { EventDateTime } from './ui/event-date-time';
import { ItemInfo } from './ui/item-info';

interface Props {
  eventInfo: Event;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  phone?: string;
  onNavigate?: () => void;
}

export const EventInfo = ({
  eventInfo,
  firstName,
  middleName,
  lastName,
  onNavigate,
}: Props): JSX.Element => {
  const { mode, address, timetable, cost, title, prepayment_cost, refusal } = eventInfo;

  const place = mode === 'N' ? 'Онлайн' : `${parseAddress(address)}`;
  const [days, hours] = getEventDaysHours(timetable);
  const hasDateStages = timetable.length > 1;

  return (
    <div className={st.info}>
      <div className={st.info__head}>
        <span className={st.title}>Участник</span>
        <Person
          firstName={firstName}
          middleName={middleName}
          lastName={lastName}
          onNavigate={onNavigate}
        />
      </div>
      <div className={st.info__body}>
        <ul className={st.list}>
          <ItemInfo title="Название" value={title} />
          <ItemInfo title="Место встречи" value={place} />
          <ItemInfo title="Часовой пояс" value={'GMT+3 МСК'} />

          {hasDateStages ? (
            <>
              <ItemInfo title={'Дата/время'} />
              {timetable.map((timeTable, index) => (
                <ItemInfo
                  key={index}
                  title={`Этап ${index + 1}`}
                  value={
                    <EventDateTime
                      date={timeTable.date}
                      timeRange={`${timeTable.time_from} - ${timeTable.time_to}`}
                    />
                  }
                />
              ))}
            </>
          ) : (
            <ItemInfo
              title={'Дата/время'}
              value={
                <EventDateTime
                  date={timetable[0].date}
                  timeRange={`${timetable[0].time_from} - ${timetable[0].time_to}`}
                />
              }
            />
          )}

          {!!days && <ItemInfo title="Кол-во дней" value={days} />}
          {!!hours && <ItemInfo title="Кол-во часов" value={hours} />}
          {refusal > 0 && (
            <ItemInfo
              title="Отменить"
              value={refusal}
              description="Время за которое вы можеье отказаться от участия в мероприятии с возвратом оплаченной суммы"
            />
          )}
          <ItemInfo title="Язык" value={'Русский'} />
          <ItemInfo title="Стоимость" value={cost / 100} />
          {prepayment_cost && <ItemInfo title="Предоплата" value={prepayment_cost / 100} />}
        </ul>
      </div>
    </div>
  );
};
